// @flow

/** region could be string (from db) or number from session, so we need to transform into a number */
class AddressInput {
  constructor({ county_fips, region, state, zipcode }) {
    this.countyFips = county_fips;
    this.region = Number(region);
    this.state = state;
    this.zipcode = zipcode;
  }
}

export default AddressInput;
